import { combineReducers } from 'redux';

import { editSchedulerReducer } from './edit/store/editScheduler.reducer';

export const machineMaintenanceSchedulerReducer = combineReducers({
    edit: editSchedulerReducer,
});
